/**
 * Internal workspaces have repositories enabled by AR:
 */
export const INTERNAL_WORKSPACE_UUIDS: string[] = [
  '{02b941e3-cfaa-40f9-9a58-cec53e20bdc3}', // atlassian
  '{42cf3134-fb8a-407a-b832-523fbaeec9d1}', // atlassian-marketplace
  '{1b4fe0ce-095a-4234-ae37-402eaf7f3584}', // atlassian mobile
  '{4cc6108a-a241-4db0-96a5-64347ac04f87}', // bitbucket
  '{3a8a18b2-55fe-49c6-9319-bf67b19a6f30}', // bitbucket ci
  '{8baebdd7-1210-4dd4-a229-9d992bf6d7ef}', // jira-service-management
  '{9f7fa1b9-b2ff-4060-b31c-e168448e9f08}', // trello
];
